import { useEffect, useRef, useState } from "react";

const LINE_HEIGHT = 28;

export const EditorSection = ({ id, file, children, testId }) => {
  const contentRef = useRef(null);
  const [lines, setLines] = useState(20);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      setLines(Math.max(8, Math.ceil(el.offsetHeight / LINE_HEIGHT)));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <section id={id} data-testid={testId} className="relative border-b border-[var(--border)]">
      <div
        aria-hidden="true"
        className="absolute left-0 top-0 bottom-0 w-10 sm:w-12 hidden sm:flex flex-col items-end pr-3 pt-10 select-none pointer-events-none font-mono text-[11px] text-[var(--muted)] opacity-40"
        style={{ lineHeight: `${LINE_HEIGHT}px` }}
      >
        {Array.from({ length: lines }, (_, i) => (
          <span key={i}>{i + 1}</span>
        ))}
      </div>
      <div ref={contentRef} className="pl-5 sm:pl-16 pr-5 md:pr-12 lg:pr-16 py-10">
        <div className="font-mono text-[11px] tracking-wider text-[var(--muted)] mb-8 flex items-center gap-1.5">
          <span className="text-[#FF5722]">portfolio</span>
          <span>›</span>
          <span>{file}</span>
        </div>
        {children}
      </div>
    </section>
  );
};
